import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { TOAST_SHOW } from "../Actions/ToastAction";
import {
  GET_REPORT_GRAPH_SUCCESS,
  GET_REPORT_GRAPH_FAIL,
  GET_CANCER_TYPE_SUCCESS,
  GET_CANCER_TYPE_FAIL,
} from "../Actions/ReportActions.js";
import decryptResponse from "../../Components/Decrypt";

export function* getReportGraphSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-report-graph`,
      action.payload
    );
    const { data } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_REPORT_GRAPH_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_REPORT_GRAPH_FAIL });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* GetCancerTypesSaga() {
  try {
    const response = yield call(axios.get, `/get-user-cancer-type`);
    const { data } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_CANCER_TYPE_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_CANCER_TYPE_FAIL });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
